import {
  ListItemIcon,
  ListItemText,
  MenuList,
  MenuItem,
  Paper,
} from '@mui/material';
import React from 'react';
import {
  AiOutlineBranches,
  AiOutlineClockCircle,
  AiOutlineDownload,
  AiOutlineEye,
  AiOutlineWarning,
} from 'react-icons/ai';
import { RiFolderTransferLine } from 'react-icons/ri';
import { BsPencil } from 'react-icons/bs';
import { FaTrashAlt } from 'react-icons/fa';
import { GrRevert } from 'react-icons/gr';
import { IRightClickMenu } from '../../interfaces/components/menu.interface';

const RightClick = ({
  menuType,
  previewCallback,
  shareCallback = undefined,
  editCallback,
  downloadCallback,
  removeFromFolderCallback,
  moveToTrashCallback,
  moveToGroupCallback,
  restoreCallback,
  hardDeleteCallback,
  moveToTrashContent = 'Chuyển vào rác',
}: IRightClickMenu) => {
  return (
    // only display menu items if there exists callback for that item
    <Paper className="w-auto text-xs px-3 sm:px-0">
      {menuType === 'deleted' ? (
        <MenuList>
          {restoreCallback && (
            <MenuItem className="w-full" onClick={() => restoreCallback()}>
              <ListItemIcon>
                <GrRevert />
              </ListItemIcon>
              <ListItemText>Khôi phục</ListItemText>
            </MenuItem>
          )}
          {hardDeleteCallback && (
            <MenuItem className="w-full" onClick={() => hardDeleteCallback()}>
              <ListItemIcon>
                <AiOutlineWarning color="#ef4748" />
              </ListItemIcon>
              <ListItemText className="text-red-500">
                Xóa vĩnh viễn
              </ListItemText>
            </MenuItem>
          )}
        </MenuList>
      ) : (
        <MenuList>
          {/* <MenuItem
            className="w-full"
            onClick={() =>
              previewCallback && previewCallback()
            }
          >
            <ListItemIcon>
              <AiOutlineEye />
            </ListItemIcon>
            <ListItemText>Xem</ListItemText>
          </MenuItem> */}
          {shareCallback && (
            <MenuItem className="w-full" onClick={() => shareCallback()}>
              <ListItemIcon>
                <AiOutlineBranches />
              </ListItemIcon>
              <ListItemText>Chia sẻ</ListItemText>
            </MenuItem>
          )}
          {editCallback && (
            <MenuItem className="w-full" onClick={() => editCallback()}>
              <ListItemIcon>
                <BsPencil />
              </ListItemIcon>
              <ListItemText>Chỉnh sửa</ListItemText>
            </MenuItem>
          )}
          {/* {moveToGroupCallback && (
            <MenuItem className="w-full" onClick={() => moveToGroupCallback()}>
              <ListItemIcon>
                <RiFolderTransferLine />
              </ListItemIcon>
              <ListItemText>Di chuyển</ListItemText>
            </MenuItem>
          )} */}
          {menuType === 'file' && downloadCallback && (
            <MenuItem className="w-full" onClick={() => downloadCallback()}>
              <ListItemIcon>
                <AiOutlineDownload />
              </ListItemIcon>
              <ListItemText>Tải về</ListItemText>
            </MenuItem>
          )}
          {/* {menuType === 'file' && removeFromFolderCallback && (
            <div className="hidden sm:block">
              <MenuItem
                className="w-full"
                onClick={() => removeFromFolderCallback()}
              >
                <ListItemIcon>
                  <AiOutlineClockCircle />
                </ListItemIcon>
                <ListItemText>Xóa khỏi thư mục</ListItemText>
              </MenuItem>
            </div>
          )} */}
          {moveToTrashCallback && (
            <MenuItem onClick={() => moveToTrashCallback()}>
              <ListItemIcon>
                <FaTrashAlt color="#ef4748" />
              </ListItemIcon>
              <ListItemText className="text-red-500">
                {moveToTrashContent}
              </ListItemText>
            </MenuItem>
          )}
        </MenuList>
      )}
    </Paper>
  );
};

export const RightClickClone: React.FC<{
  activeItem: any | null;
  children: React.ReactElement;
}> = ({ activeItem, children }) => {
  return React.cloneElement(
    children as React.ReactElement<IRightClickMenu>,
    {
      previewCallback: children.props?.previewCallback && children.props?.previewCallback(activeItem)
        ? children.props?.previewCallback(activeItem)
        : undefined,
      shareCallback: children.props?.shareCallback && children.props?.shareCallback(activeItem)
        ? children.props?.shareCallback(activeItem)
        : undefined,
      editCallback: children.props?.editCallback && children.props?.editCallback(activeItem)
        ? children.props?.editCallback(activeItem)
        : undefined,
      downloadCallback: children.props?.downloadCallback && children.props?.downloadCallback(activeItem)
        ? children.props?.downloadCallback(activeItem)
        : undefined,
      removeFromFolderCallback: children.props?.removeFromFolderCallback && children.props?.removeFromFolderCallback(activeItem)
        ? children.props?.removeFromFolderCallback(activeItem)
        : undefined,
      moveToTrashCallback: children.props?.moveToTrashCallback && children.props?.moveToTrashCallback(activeItem)
        ? children.props?.moveToTrashCallback(activeItem)
        : undefined,
      restoreCallback: children.props?.restoreCallback && children.props?.restoreCallback(activeItem)
        ? children.props?.restoreCallback(activeItem)
        : undefined,
      hardDeleteCallback: children.props?.hardDeleteCallback && children.props?.hardDeleteCallback(activeItem)
        ? children.props?.hardDeleteCallback(activeItem)
        : undefined,
    },
    null
  );
};

export default RightClick;
